import { render, staticRenderFns } from "./CarePairing.vue?vue&type=template&id=143a7f5e&scoped=true&"
import script from "./CarePairing.vue?vue&type=script&lang=js&"
export * from "./CarePairing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a7f5e",
  null
  
)

export default component.exports